import { withEditPermissionCheck } from '@app/shared/hocs/withEditPermissionCheck';
import { ButtonWithHintText } from '../ButtonWithHintText';

export const ProtectedButtonWithHint = withEditPermissionCheck(
  ButtonWithHintText
);
